import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [params] = useSearchParams();
  const sessionExpired = params.get("session") === "expired";
  // Preference order: sessionStorage stash from a 401, route state.from, default dashboard
  const stashed = typeof window !== "undefined" ? sessionStorage.getItem("aviana_return_to") : null;
  const dest = stashed || loc.state?.from || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (sessionExpired) toast.error("Your session expired — please sign in to continue where you left off.");
  }, [sessionExpired]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      sessionStorage.removeItem("aviana_return_to");
      toast.success("Welcome back, sister.");
      nav(dest);
    } else {
      setErr(res.error);
    }
  };

  return (
    <div className="pt-32 pb-24 min-h-screen" data-testid="login-page">
      <div className="container-aviana max-w-md">
        <p className="overline mb-3">Sign in</p>
        <h1 className="font-serif text-5xl text-aviana-ink">Welcome back.</h1>
        <p className="mt-3 text-aviana-muted">Continue your journey with Aviana.</p>

        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="login-form">
          <div>
            <label className="overline">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-aviana-border focus:border-aviana-gold py-3 outline-none" data-testid="login-email" />
          </div>
          <div>
            <label className="overline">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-aviana-border focus:border-aviana-gold py-3 outline-none" data-testid="login-password" />
          </div>
          {err && <p className="text-sm text-red-700" data-testid="login-error">{err}</p>}
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="mt-6 text-sm text-aviana-muted">
          <Link to="/forgot-password" className="text-aviana-plum hover:text-aviana-goldDeep underline underline-offset-4" data-testid="forgot-password-link">
            Forgot your password?
          </Link>
        </p>

        <p className="mt-8 text-sm text-aviana-muted">
          New to Aviana? <Link to="/signup" className="text-aviana-plum underline underline-offset-4">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
